import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_z588h499tw: FaireBrandEntity = {
  token: "b_z588h499tw",
  type: "brand",
  name: "LOHSO",
  avatarUrl:
    "https://cdn.faire.com/fastly/c3d7adb5a13f00c481755bc99d0a6c8cc923ca696dd386846610d58355666d77.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ffecfd7ee8f8037fd9cbe306cfd5f01884bef57b2aa5af26d2bd8806d131e489.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c3d7adb5a13f00c481755bc99d0a6c8cc923ca696dd386846610d58355666d77.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ffecfd7ee8f8037fd9cbe306cfd5f01884bef57b2aa5af26d2bd8806d131e489.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 64,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "LOHSO started from a personal shift in how I approached food, health, and the products I brought into my daily routine.\n\nAfter losing over 100 pounds, I became more intentional about ingredients and how products made me feel. I found that some of my favorite kitchen staples were high in sodium, filled with hidden ingredients, or lacked depth in flavor completely. \n\nI created LOHSO to change that.\n\nLOHSO is a modern take on a pantry essential - made from organically sourced coconut sap, naturally fermented and slow-reduced into a rich, umami sauce. It delivers everything you want from soy sauce, with 53% less sodium and none of the compromises - no soy, no gluten, no additives, and no shortcuts.\n\nFrom my kitchen to yours, I hope you enjoy!\nLauren, Founder of LOHSO",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:08.156Z",
    importedBy: "entity-db-cli",
  },
};
